import { ReactNode } from "react";

type SearchFilterContainerProps = {
  children: ReactNode;
};
function SearchFilterContainer({ children }: Readonly<SearchFilterContainerProps>) {
  return <div className="flex items-center justify-between pb-2">{children}</div>;
}
export default SearchFilterContainer;
